import React from 'react';
import { Database } from 'shared/database.enum';
import { ReactComponent as MerinoSelectIcon } from 'assets/images/merino-select-asbv.svg';
import { ReactComponent as DohneIcon } from 'assets/images/dohne-asbv.svg';
import { ReactComponent as LambplanIcon } from 'assets/images/lambplan-asbv.svg';
import { ReactComponent as KidplanIcon } from 'assets/images/kidplan-asbv.svg';
import { BreedingServiceLogoProps } from './breeding-service-logo-props';

/**
 * Displays an ASBV logo for the given database.
 * @param props
 */
export const BreedingServiceLogo: React.FC<BreedingServiceLogoProps> = (props) => {
  const {
    db,
    className,
  } = props;

  const Logo = () => {
    switch (db) {
      case Database.TerminalAll:
      case Database.TerminalShedders:
      case Database.MaternalAll:
      case Database.MaternalFirstCrossSire:
      case Database.MaternalCorriedale:
      case Database.MaternalPrimeSAMMs:
      case Database.LambplanAll:
      case Database.LambplanTerminal:
      case Database.LambplanMaternal:
      case Database.LambplanFirstCross:
      case Database.LambplanCorriedale:
      case Database.LambplanShedders:
        return <LambplanIcon className={className} />;
      case Database.Merino:
        return <MerinoSelectIcon className={className} />;
      case Database.Dohne:
        return <DohneIcon className={className} />;
      case Database.Boer:
        return <KidplanIcon className={className} />;
      default:
        throw new Error('There was an error matching the db value to a logo');
    }
  };

  return (
    <Logo />
  );
};
